import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../lib/auth";

/**
 * Effect-only route. POSTs /api/auth/logout, clears the React Query cache, and
 * redirects to the landing page. Renders a brief editorial line while waiting.
 */
export default function LogoutPage() {
  const { mutate } = useLogout();
  const navigate = useNavigate();

  useEffect(() => {
    mutate(undefined, {
      onSettled: () => {
        navigate("/", { replace: true });
      },
    });
    // We deliberately don't include `mutate` / `navigate` in deps — fires once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="min-h-[100svh] flex flex-col items-center justify-center px-6">
      <span
        aria-hidden
        className="font-deva text-[3rem] mb-6"
        style={{ color: "var(--color-violet)", opacity: 0.4 }}
      >
        विदा
      </span>
      <p className="font-display-italic text-[1.5rem] text-[var(--color-ink-mute)]">
        Signing out…
      </p>
    </main>
  );
}
